module.exports = __webpack_public_path__ + "static/media/b0_p1_melody.fb19a45e.mp3";